// extracted by mini-css-extract-plugin
export default {"policyText":"contentResponsibilityPolicyText__policyText--hl8DT","policyLink":"contentResponsibilityPolicyText__policyLink--Vqmlo"};